import { Wrench, Terminal as TermIcon, Bug } from 'lucide-react';

export default function ToolboxSidebar() {
  return (
    <div className="w-8 bg-[#252526] border-r border-[#333] flex flex-col items-center py-2 gap-4 flex-shrink-0">
      <Wrench   size={16} className="text-[#666] hover:text-[#ccc] cursor-pointer"/>
      <TermIcon size={16} className="text-[#666] hover:text-[#ccc] cursor-pointer"/>
      <Bug      size={16} className="text-[#666] hover:text-[#ccc] cursor-pointer"/>
    </div>
  );
}
